import React, { memo } from 'react'
import times from 'lodash/times'
import { Box } from 'transfix-ui/core'
import Skeleton from 'transfix-ui/core/Skeleton'
import { brandColors } from 'transfix-ui'
import DetailCaption from './DetailCaption'

export interface IDetailItemProps {
  title: string
  value: React.ReactNode
  isEmpty?: boolean
  emptyState?: React.ReactNode
  isLoading: boolean
  /**
   * Set the title width
   * @default 112
   */
  titleWidth?: number
  /**
   * Set the title width
   * @default 112
   */
  descriptionWidth?: number
  /**
   * This prop is to provide a loading element
   * @default <Skeleton />
   */
  loadingNode?: React.ReactNode
}

export interface IMultipleSkeletonsProps {
  count?: number
}

export const MultipleSkeletons = memo<IMultipleSkeletonsProps>(({ count = 0 }) => (
  <div>
    {times(count).map(index => (
      <div key={index}>
        <Skeleton />
      </div>
    ))}
  </div>
))

export const DetailItem = ({
  title,
  value,
  isEmpty = false,
  emptyState,
  isLoading,
  titleWidth = 112,
  descriptionWidth = 200,
  loadingNode = <Skeleton />,
}: IDetailItemProps) => {
  return (
    <Box display='grid' gridTemplateColumns={`${titleWidth}px auto`} mt={0.75}>
      <Box flex={`${titleWidth}px`} color={brandColors.coolGray5}>
        <DetailCaption>{title}:</DetailCaption>
      </Box>
      {isLoading ? loadingNode : <Box width={descriptionWidth}>{isEmpty ? emptyState : value}</Box>}
    </Box>
  )
}
